import LegalLayout from './LegalLayout';

export default function TermsPage() {
  return (
    <LegalLayout title="Termini e Condizioni di Servizio" lastUpdate="26 Aprile 2026">
      <h2 className="font-outfit text-xl font-bold text-slate-800 mt-0">1. Premessa</h2>
      <p className="text-slate-700">
        I presenti Termini e Condizioni regolano l'utilizzo della piattaforma <strong>Kyloo</strong>
        (di seguito "il Servizio"), accessibile tramite il sito kyloo.it. Utilizzando il Servizio,
        l'utente dichiara di aver letto, compreso e accettato i presenti Termini.
      </p>

      <h2 className="font-outfit text-xl font-bold text-slate-800">2. Descrizione del Servizio</h2>
      <p className="text-slate-700">
        Kyloo è una piattaforma che consente agli utenti di cercare e individuare prodotti disponibili
        in negozi fisici nelle vicinanze e ai negozianti di pubblicare il proprio catalogo prodotti.
        Il Servizio è offerto in versione <strong>beta gratuita</strong> e potrebbe subire modifiche,
        interruzioni o sospensioni in qualsiasi momento.
      </p>

      <h2 className="font-outfit text-xl font-bold text-slate-800">3. Registrazione e account</h2>
      <p className="text-slate-700">
        La consultazione del Servizio è gratuita e non richiede registrazione. Per funzionalità avanzate
        (preferiti, gestione negozio) è necessario creare un account tramite Google OAuth o email + password.
      </p>
      <p className="text-slate-700">L'utente si impegna a:</p>
      <ul className="text-slate-700">
        <li>Fornire informazioni veritiere e aggiornate</li>
        <li>Mantenere la riservatezza delle proprie credenziali</li>
        <li>Non condividere il proprio account con terzi</li>
        <li>Notificare immediatamente al Titolare qualsiasi uso non autorizzato dell'account</li>
      </ul>

      <h2 className="font-outfit text-xl font-bold text-slate-800">4. Obblighi del negoziante</h2>
      <p className="text-slate-700">L'utente che si registra come negoziante (professionista) si impegna a:</p>
      <ul className="text-slate-700">
        <li>Pubblicare solo prodotti effettivamente disponibili presso il proprio punto vendita fisico</li>
        <li>Inserire informazioni veritiere su prezzo, disponibilità, descrizione e foto</li>
        <li>Mantenere aggiornati gli orari di apertura</li>
        <li>Rispettare le normative italiane ed europee in materia di commercio, etichettatura, fiscalità</li>
        <li>Possedere una valida partita IVA e tutti i requisiti legali per esercitare la propria attività</li>
        <li>Non pubblicare prodotti contraffatti, illegali o che violino diritti di terzi</li>
      </ul>
      <p className="text-slate-700">
        Il Titolare si riserva il diritto di rimuovere prodotti o sospendere account che violano questi obblighi,
        senza preavviso.
      </p>

      <h2 className="font-outfit text-xl font-bold text-slate-800">5. Utilizzi vietati</h2>
      <p className="text-slate-700">È vietato:</p>
      <ul className="text-slate-700">
        <li>Utilizzare il Servizio per fini illegali o lesivi di diritti altrui</li>
        <li>Tentare di accedere a sezioni riservate o di compromettere la sicurezza della piattaforma</li>
        <li>Effettuare scraping, reverse engineering o reverse del codice</li>
        <li>Caricare contenuti offensivi, violenti, discriminatori, pornografici o protetti da copyright altrui</li>
        <li>Inviare spam, virus o codice malevolo</li>
        <li>Creare account falsi o multipli con finalità fraudolente</li>
      </ul>

      <h2 className="font-outfit text-xl font-bold text-slate-800">6. Proprietà intellettuale</h2>
      <p className="text-slate-700">
        Il marchio "Kyloo", il logo, l'interfaccia grafica e i contenuti originali della piattaforma sono di
        proprietà esclusiva del Titolare. È vietato qualsiasi utilizzo non autorizzato.
      </p>
      <p className="text-slate-700">
        I contenuti caricati dai negozianti (foto prodotti, descrizioni) restano di loro proprietà; con il
        caricamento, il negoziante concede al Titolare una licenza non esclusiva, mondiale e gratuita di
        utilizzo, riproduzione e visualizzazione di tali contenuti ai soli fini dell'erogazione del Servizio.
      </p>

      <h2 className="font-outfit text-xl font-bold text-slate-800">7. Limitazioni di responsabilità</h2>
      <p className="text-slate-700">Il Titolare:</p>
      <ul className="text-slate-700">
        <li>Non è parte delle eventuali transazioni commerciali tra utenti e negozianti</li>
        <li>Non garantisce l'effettiva disponibilità o le caratteristiche dei prodotti pubblicati dai negozianti</li>
        <li>Non risponde di eventuali errori, omissioni o ritardi nelle informazioni pubblicate</li>
        <li>Non risponde di danni derivanti da malfunzionamenti, interruzioni del Servizio o cause di forza maggiore</li>
        <li>Fornisce il Servizio "as is", senza garanzie di alcun tipo</li>
      </ul>

      <h2 className="font-outfit text-xl font-bold text-slate-800">8. Recesso e cancellazione account</h2>
      <p className="text-slate-700">
        L'utente può cancellare il proprio account in qualsiasi momento contattando
        <strong> kyloo.app@libero.it</strong>. Il Titolare si riserva il diritto di sospendere o eliminare
        account che violino i presenti Termini.
      </p>

      <h2 className="font-outfit text-xl font-bold text-slate-800">9. Modifiche ai Termini</h2>
      <p className="text-slate-700">
        Il Titolare si riserva il diritto di modificare i presenti Termini in qualsiasi momento. Le modifiche
        saranno pubblicate in questa pagina e diventeranno efficaci immediatamente. L'uso continuativo del
        Servizio dopo la modifica costituisce accettazione dei nuovi Termini.
      </p>

      <h2 className="font-outfit text-xl font-bold text-slate-800">10. Legge applicabile e foro competente</h2>
      <p className="text-slate-700">
        I presenti Termini sono disciplinati dalla legge italiana. Per qualsiasi controversia, il foro
        competente è quello del luogo di residenza del consumatore se applicabile, in via residuale il foro
        della sede del Titolare.
      </p>

      <h2 className="font-outfit text-xl font-bold text-slate-800">11. Contatti</h2>
      <p className="text-slate-700">
        Per qualsiasi domanda relativa ai presenti Termini, scrivi a <strong>kyloo.app@libero.it</strong>.
      </p>
    </LegalLayout>
  );
}
